import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MxAlertService, MxBaseRestService } from 'mx-commons';
import { StepAnalyseEnum } from 'src/app/model/analyse-credit';
import {
  Indicator,
  ParecerIndicativo,
  PowersStep,
} from 'src/app/model/indicator';
import { Mail, MailAuthType } from 'src/app/model/mail';
import { routerTransition } from 'src/app/router.animations';
import {
  isNotNullAndUndefined,
  isNullOrUndefined,
  validateNumericRangeParecerIndicativo,
} from 'src/app/shared/helpers/utils';
import { SaveService } from 'src/app/shared/services/save.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import {
  ISysUpdate,
  UpdateService,
  SysUpdateEnum,
  IJenkinsData,
} from 'src/app/shared/services/update.service';
import {
  ConfigurationService,
  ILgpdDoc,
  IAcceptanceTerm,
  IResendNotification,
  IManual,
  ILogo,
} from './configuration.service';

import { saveAs as importedSaveAs } from 'file-saver';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { AttachmentInfo, Lgpd } from 'src/app/model/lgpd';
import { LgpdExpiration } from 'src/app/model/lgpd-expiration';
import {
  IResponseDownload,
  UploadService,
} from 'src/app/shared/components/upload/upload.service';
import { formatToDate } from 'src/app/shared/formatters';
import { AccessControl } from 'src/app/model/access-control';
import { HttpParams } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Color } from 'src/app/model/color';
import { environment } from 'src/environments/environment';
import millisecondsToDateString, { millisecondsToDateStringAndHours } from '../../shared/helpers/millisecondsToDateString';
@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  animations: [routerTransition()],
})
export class ConfigurationComponent implements OnInit {
  formGroupIndicator: FormGroup;
  formGroupMail: FormGroup;
  formGroupLGPD: FormGroup;
  formGroupLgpdExpiration: FormGroup;
  formGroupCriterionGroup: FormGroup;
  formGroupAccessControl: FormGroup;
  formGroupResendNotification: FormGroup;
  pageSelected = PageEnum.INDICATOR;
  PageEnum = PageEnum;
  indicator: Indicator = null;
  mail: Mail = null;
  lgpd: Lgpd = null;
  resendNotification: IResendNotification = null;
  hoursToResendNotification: number = null;
  listTLS = ['Sim', 'Não'];
  listSSL = ['Sim', 'Não'];
  isLoading = false;
  uploadData: string = '';
  lgpdExpiration: LgpdExpiration = null;
  accessControl: AccessControl = null;
  listResponseType = ['code'];
  listResponseMode = ['query'];
  listGrantType = ['authorization_code'];
  formGroupMailOAuth2: FormGroup;
  isAdvancedConfig: boolean = true;

  savingLogo: boolean = false;
  public logo: ILogo = null;
  private readonly LOGO = 'logo';
  private readonly COLOR = 'color/findAll';
  formGroupMainColor: FormGroup;
  listLogoType = ['LOGIN', 'FUNDO'];
  logoType: string = null;
  public color: Color = new Color();
  logoPreview = null;

  public fileLgpd: ILgpdDoc = null;
  public files: NgxFileDropEntry[] = [];
  public resizedFiles: Array<File> = new Array<File>();
  filesList: Array<AttachmentInfo> = new Array<AttachmentInfo>();
  private readonly ACCEPTANCE_TERM_URL = 'acceptanceterm/';
  private readonly MANUAL_URL = 'manual/';
  private readonly LGPD_URL = 'lgpd/';
  public savingAcceptanceTerm: boolean = false;
  public savingManual: boolean = false;
  public savingLGPD: boolean = false;
  public acceptanceTerm: IAcceptanceTerm = null;
  public manual: IManual = null;
  public lastUpdate: ISysUpdate;
  private readonly currentBranch: string = environment.gitLab.sourceBranch;
  private readonly targetBranch: string = environment.gitLab.targetBranch;
  private readonly jenkinsUrlApi: string = environment.jenkins.urlApi;
  private readonly jenkinsUrlView: string = environment.jenkins.urlView;
  private readonly jenkinsUser: string = environment.jenkins.username;
  private readonly jenkinsPasword: string = environment.jenkins.password;
  private readonly jenkinsEnvironment: string = environment.jenkins.environment;
  private user: string;
  private enableUpdate: boolean = false;
  private updateMsg: string = '';
  private updateMsgDetail: string = '';
  private enableUpdateBtn: boolean = false;

  constructor(
    private readonly restService: MxBaseRestService,
    private readonly utilsService: UtilsService,
    private readonly alertService: MxAlertService,
    private readonly authService: SaveService,
    private readonly formBuilder: FormBuilder,
    private readonly uploadService: UploadService,
    private readonly mxUploading: EventEmitter<boolean>,
    private readonly configurationService: ConfigurationService,
    private sanitizer: DomSanitizer,
    private readonly updateService: UpdateService
  ) {}

  async ngOnInit(): Promise<void> {
    this.user = sessionStorage.getItem('user');
    await this.loadFromApi();
    await this.getLastLgpd();
    await this.getExpirationDays();
    await this.getLastAcceptanceTerm();
    await this.getAccessControl();
    await this.getHoursToResendNotification();
    await this.getLastManual();
    await this.getLogo();
    await this.getColor('MAIN');
    await this.getLastUpdate();
  }

  async saveExpirationDays() {
    const isNumber = Number(
      this.formGroupLgpdExpiration.getRawValue().lgpdExpire
    );
    console.log(isNumber);
    if (Number.isNaN(isNumber)) {
      this.alertService.warning('Valor inválido!');
      this.authService.saving = false;
    } else {
      try {
        //const days = this.formGroupLgpdExpiration.getRawValue();
        this.lgpdExpiration.daysToExpire = Math.trunc(isNumber);
        await this.restService
          .post('lgpd-expiration', '', this.lgpdExpiration)
          .toPromise();
        this.alertService.success('Salvo com sucesso');
      } catch (e) {
        this.alertService.error(e.message);
      } finally {
        this.authService.saving = false;
      }
    }
  }

  async getExpirationDays() {
    try {
      const lgpdExpiration = await this.restService
        .getter('lgpd-expiration', '', '')
        .toPromise();
      this.lgpdExpiration = lgpdExpiration
        ? lgpdExpiration
        : new LgpdExpiration();
      this.createFormLgpdExpiration(lgpdExpiration);
    } catch (e) {
      this.alertService.error(e.message);
    }
  }

  public getLastLgpd(): void {
    //const url = `lgpd/lastdownload`;
    this.configurationService
      .getLastLgpd(this.LGPD_URL + 'lastdownload')
      .then((res) => {
        //console.log("Response da ultima lgpd ->",res);
        if (res != undefined) {
          this.fileLgpd = res as ILgpdDoc;
          this.uploadData = this.formatDate(res.createdAt);
        }
      });
  }

  public getLastAcceptanceTerm(): void {
    this.configurationService
      .getLastAcceptanceTerm(this.ACCEPTANCE_TERM_URL + 'last')
      .then((res) => {
        if (res) this.acceptanceTerm = res;
      });
  }

  formatDate(milliseconds: number): string {
    //lógica para gerar a data
    function fixMin(min) {
      return min < 10 ? '0' + min : min;
    }
    function fixHour(h) {
      return h < 10 ? '0' + h : h;
    }
    const day = new Date(milliseconds);
    let hour = fixHour(day.getHours());
    let min = fixMin(day.getMinutes());
    const date = formatToDate(milliseconds);
    return `${date} às ${hour}:${min}`;
  }

  downloadLgpd() {
    if (this.fileLgpd.attachment.attachmentId) {
      this.uploadService
        .download(`files/${this.fileLgpd.attachment.attachmentId}`, {
          responseType: 'blob',
        })
        .subscribe((response: IResponseDownload) => {
          if (response && response.blob) {
            importedSaveAs(response.blob, response.fileName);
            this.alertService.success(`Anexo baixado com sucesso.`);
          } else {
            this.alertService.error('Problema ao fazer o download do arquivo!');
          }
        });
    }
  }

  downloadAcceptanceTerm(): void {
    if (this.acceptanceTerm.attachment.attachmentId) {
      this.uploadService
        .download(`files/${this.acceptanceTerm.attachment.attachmentId}`, {
          responseType: 'blob',
        })
        .subscribe(
          (response: IResponseDownload) => {
            if (response && response.blob)
              importedSaveAs(response.blob, response.fileName);
          },
          (error) => {
            this.alertService.error(
              'Ocorreu um erro ao baixar o termo de uso.'
            );
            console.error(error);
          }
        );
    }
  }

  // method to handle upload
  public dropped(files: NgxFileDropEntry[]) {
    if (this.savingLGPD) return;
    this.files = files;
    if (files.length > 1) {
      this.alertService.warning('Mais que um arquivo!');
      return;
    }
    for (const droppedFile of files) {
      this.savingLGPD = true;
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file(async (file: File) => {
          //se não há arquivos com mesmo nome faça
          if (
            this.filesList.filter((f) => f.description === file.name).length ===
            0
          ) {
            const newFile = await this.uploadService
              .checkImageAndResize(file)
              .toPromise();
            this.resizedFiles.push(newFile);
            this.mxUploading.emit(true);
            try {
              this.alertService.info('Realizando Upload do termo LGPD!');
              await this.uploadService.upload(
                this.LGPD_URL + 'upload',
                newFile
              );
              // Atualiza o anexo em tela caso não ocorra erros
              this.getLastLgpd();

              this.alertService.success(
                'Arquivo enviado ao servidor e atualizado com sucesso!'
              );
            } catch (e) {
              this.alertService.error(
                'Ocorreu um erro durante envio do termo LDPG para o servidor!'
              );
              console.error(e);
            } finally {
              this.savingLGPD = false;
            }
          } else {
            console.log('Arquivo já adicionado');
          }
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        //   const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        //   console.log(droppedFile.relativePath, fileEntry);
      }
    }
  }

  async delete(index: number) {
    this.files.splice(index, 1);
  }

  public droppedAcceptanceTerm(files: NgxFileDropEntry[]): void {
    if (this.savingAcceptanceTerm) return;
    if (files.length && files.length > 1) {
      this.alertService.warning('É permitido o upload de apenas um arquivo.');
      return;
    }

    try {
      this.savingAcceptanceTerm = true;
      for (const droppedFile of files) {
        if (droppedFile.fileEntry.isFile) {
          const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
          fileEntry.file(async (file: File) => {
            if (
              this.acceptanceTerm &&
              this.acceptanceTerm.attachment.description === file.name
            ) {
              this.alertService.warning('Nome de arquivo já existente.');
              return;
            }
            const newFile = await this.uploadService
              .checkImageAndResize(file)
              .toPromise();
            this.resizedFiles.push(newFile);
            this.mxUploading.emit(true);

            try {
              this.alertService.info('Realizando Upload do Termo de Uso!');
              await this.uploadService.upload(
                this.ACCEPTANCE_TERM_URL + 'upload',
                newFile
              );
              // Atualiza o anexo em tela caso não ocorra erros
              this.getLastAcceptanceTerm();

              this.alertService.success(
                'Arquivo enviado ao servidor e atualizado com sucesso!'
              );
            } catch (e) {
              this.alertService.error(
                'Ocorreu um erro durante envio do termo de uso para o servidor!'
              );
              console.error(e);
            }
          });
        }
      }
    } finally {
      this.savingAcceptanceTerm = false;
    }
  }

  private createFormLGPD(): void {
    this.formGroupLGPD = this.formBuilder.group({
      name: [
        this.lgpd.name,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(50),
        ]),
      ],
    });
  }

  private createPowerStep(power?: PowersStep): FormGroup {
    console.log('createpower => ', power);
    return this.formBuilder.group({
      step: [
        power ? power.step : null,
        Validators.compose([Validators.required]),
      ],
      value: [
        power ? power.value : null,
        Validators.compose([Validators.required, Validators.min(0)]),
      ],
      acceptance: [
        power ? power.acceptance : null,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(10),
        ]),
      ],
    });
  }

  private async loadFromApi(): Promise<void> {
    try {
      this.isLoading = true;
      const indicator = await this.restService
        .getter('indicator', '', '')
        .toPromise();

      if (isNotNullAndUndefined(indicator)) {
        if (indicator.powersStep.length === 0) {
          indicator.powersStep = [
            { step: StepAnalyseEnum.GERENTE_LOJA, value: 0, acceptance: 0 },
            { step: StepAnalyseEnum.CORPORATIVO, value: 0, acceptance: 0 },
          ];
        }
        this.indicator = indicator;
        this.createFormIndicator(indicator);
      } else {
        this.indicator = new Indicator();
        this.createFormIndicator(this.indicator);
      }

      const mail = await this.restService
        .getter('mailconfiguration', '', '')
        .toPromise();
      if (isNotNullAndUndefined(mail)) {
        this.mail = mail;
      } else {
        this.mail = new Mail();
      }

      if (this.mail.mailAuthType == MailAuthType.OAUTH2) {
        this.isAdvancedConfig = true;
      } else {
        this.isAdvancedConfig = false;
      }

      this.createFormMail();
      this.createFormMailOAuth2();

      this.lgpd = new Lgpd();

      this.createFormLGPD();
    } finally {
      this.isLoading = false;
    }
  }

  private createFormIndicator(indicator: Indicator): void {
    this.formGroupIndicator = this.formBuilder.group({
      valorRecEntradaVenda: [
        indicator.valorRecEntradaVenda,
        Validators.compose([Validators.required, Validators.min(0)]),
      ],
      valorRecCustoProduto: [
        indicator.valorRecCustoProduto,
        Validators.compose([Validators.required, Validators.min(0)]),
      ],
      valorLimiteCompometido: [
        indicator.valorLimiteCompometido,
        Validators.compose([Validators.required, Validators.min(0)]),
      ],
      valorLimiteMargem: [
        indicator.valorLimiteMargem,
        Validators.compose([Validators.required, Validators.min(0)]),
      ],
      prazoVendaFatur: [
        indicator.prazoVendaFatur,
        Validators.compose([Validators.required, Validators.min(0)]),
      ],
      tempoEstoque: [
        indicator.tempoEstoque,
        Validators.compose([Validators.required, Validators.min(0)]),
      ],
      daysToValidity: [
        indicator.daysToValidity,
        Validators.compose([Validators.required, Validators.min(0)]),
      ],
      // caixaComprometido: [
      // 	indicator.caixaComprometido,
      // 	Validators.compose([Validators.required, Validators.min(0)])
      // ],
      daysHistoryCustomer: [
        indicator.daysHistoryCustomer,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(3650),
        ]),
      ],
      parecerIndicativo: this.formBuilder.array(
        indicator.parecerIndicativo.map((p) => this.createParecer(p))
      ),
      powersStep: this.formBuilder.array(
        indicator.powersStep.map((p) => this.createPowerStep(p))
      ),
    });
  }

  private createFormLgpdExpiration(lgpdExpiration: LgpdExpiration): void {
    this.formGroupLgpdExpiration = this.formBuilder.group({
      lgpdExpire: [
        this.lgpdExpiration.daysToExpire,
        Validators.compose([Validators.required]),
      ],
    });
  }

  private createFormMail(): void {
    const validatorsPass = [Validators.minLength(3)];
    if (isNullOrUndefined(this.mail.createdAt)) {
      validatorsPass.push(Validators.required);
    }

    this.formGroupMail = this.formBuilder.group({
      host: [
        this.mail.host,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(50),
        ]),
      ],
      port: [this.mail.port, Validators.compose([Validators.min(0)])],
      username: [
        this.mail.username,
        Validators.compose([
          Validators.required,
          Validators.min(5),
          Validators.max(50),
        ]),
      ],
      password: [null, Validators.compose(validatorsPass)],
      displayName: [
        this.mail.displayName,
        Validators.compose([
          Validators.required,
          Validators.min(5),
          Validators.max(50),
        ]),
      ],
      useTLS: [
        this.mail.useTLS ? 'Sim' : 'Não',
        Validators.compose([Validators.min(1)]),
      ],
      useSSL: [
        this.mail.useSSL ? 'Sim' : 'Não',
        Validators.compose([Validators.min(1)]),
      ],
      mailAuthType: [MailAuthType.BASIC_AUTH, Validators.required],
    });
  }

  private createFormMailOAuth2(): void {
    this.formGroupMailOAuth2 = this.formBuilder.group({
      username: [this.mail.username, Validators.required],
      host: [this.mail.host, Validators.required],
      port: [this.mail.port, Validators.required],
      clientId: [this.mail.clientId, Validators.required],
      tenantId: [this.mail.tenantId, Validators.required],
      secret: [this.mail.secret, Validators.required],
      responseType: [this.mail.responseType, Validators.required],
      responseMode: [this.mail.responseMode, Validators.required],
      scope: [this.mail.scope, Validators.required],
      mailAuthType: [MailAuthType.OAUTH2, Validators.required],
      useTLS: [true],
      useSSL: [false],
      redirectUri: [
        environment.baseUrl + environment.baseApi + 'mailconfiguration/token',
      ],
    });
  }

  private createParecer(parecer?: ParecerIndicativo): FormGroup {
    console.log('createparecer => ', parecer);
    return this.formBuilder.group({
      description: [
        parecer ? parecer.description : null,
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
        ]),
      ],
      color: [parecer ? parecer.color : null, Validators.compose([])],
      valueEnd: [
        parecer ? parecer.valueEnd : null,
        Validators.compose([Validators.required, Validators.minLength(0)]),
      ],
      valueStart: [
        parecer ? parecer.valueStart : null,
        Validators.compose([Validators.required, Validators.minLength(0)]),
      ],
    });
  }

  private createFormAccessControl(): void {
    this.formGroupAccessControl = this.formBuilder.group({
      timeout: [
        this.accessControl.timeout,
        Validators.compose([Validators.required]),
      ],
      simulAccessWeb: [
        this.accessControl.simulAccessWeb,
        Validators.compose([Validators.required]),
      ],
      simulAccessMobile: [
        this.accessControl.simulAccessMobile,
        Validators.compose([Validators.required]),
      ],
      timeToChangePassword: [
        this.accessControl.timeToChangePassword,
        Validators.compose([Validators.required]),
      ],
    });
  }

  getParecer(): FormArray {
    return <FormArray>this.formGroupIndicator.get('parecerIndicativo');
  }

  addParecer(): void {
    this.getParecer().push(this.createParecer());
  }

  removeAcceptanceTerm(): void {
    try {
      this.uploadService.delete(
        this.ACCEPTANCE_TERM_URL + this.acceptanceTerm.id
      );
      this.acceptanceTerm = null;
    } catch (e) {
      this.alertService.error(
        'Ocorreu um erro durante remoção do termo de uso!'
      );
      console.error(e);
    }
  }

  removeParecer(i: number) {
    this.getParecer().removeAt(i);
  }

  getPowers(): FormArray {
    return <FormArray>this.formGroupIndicator.get('powersStep');
  }

  async saveIndicator(): Promise<void> {
    try {
      if (this.formGroupIndicator.invalid) {
        this.alertService.warning(
          'Dados obrigatórios não informados ou inválidos!'
        );
        this.utilsService.validateAllFormFields(this.formGroupIndicator);
        return;
      }

      const dados = {
        ...this.indicator,
        ...this.formGroupIndicator.getRawValue(),
      };

      const responseValidateParecerIndicativo = this.validateParecerIndicativo(
        dados.parecerIndicativo
      );

      if (responseValidateParecerIndicativo !== null) {
        this.alertService.warning(responseValidateParecerIndicativo);
      } else {
        await this.restService.post('indicator', '', dados).toPromise();

        this.alertService.success('Salvo com sucesso!');
      }
    } catch (error) {
      console.log(error);
      this.alertService.error(
        'Ocorreu um arro ao salvar. Verifique os valores e tente novamente'
      );
    } finally {
      this.authService.saving = false;
    }
  }

  async saveMail(): Promise<void> {
    try {
      if (this.formGroupMail.invalid) {
        this.alertService.warning(
          'Dados obrigatórios não informados ou inválidos!'
        );
        this.utilsService.validateAllFormFields(this.formGroupMail);
        return;
      }

      let dados = { ...this.mail, ...this.formGroupMail.getRawValue() };

      dados.useTLS = dados.useTLS == 'Sim' ? true : false;
      dados.useSSL = dados.useSSL == 'Sim' ? true : false;

      await this.restService.post('mailconfiguration', '', dados).toPromise();

      this.alertService.success('Salvo com sucesso!');
    } catch (error) {
      console.log(error);
      this.alertService.error(
        'Ocorreu um erro ao salvar. Verifique os valores e tente novamente'
      );
    } finally {
      this.authService.saving = false;
    }
  }

  async saveMailOAuth2(): Promise<void> {
    try {
      if (this.formGroupMailOAuth2.invalid) {
        this.alertService.warning(
          'Dados obrigatórios não informados ou inválidos!'
        );
        this.utilsService.validateAllFormFields(this.formGroupMailOAuth2);
        return;
      }

      const dados = { ...this.mail, ...this.formGroupMailOAuth2.getRawValue() };
      await this.restService.post('mailconfiguration', '', dados).toPromise();

      this.alertService.success('Salvo com sucesso!');
    } catch (error) {
      console.log(error);
      this.alertService.error(
        'Ocorreu um erro ao salvar. Verifique os valores e tente novamente'
      );
    } finally {
      this.authService.saving = false;
    }
  }

  onPageChange(page: PageEnum): void {
    this.pageSelected = page;
  }

  // Validar os dados do parecer indicativo
  // Cor não pode ser null
  // valueStart e valueEnd entre os pareceres não podem conflitar
  // Retorna uma messagem de erro caso invalido
  // Retorna null caso valido
  validateParecerIndicativo(parecerIndicativoList) {
    for (let parecer of parecerIndicativoList) {
      console.log('parecer-> ', parecer);

      // Validar para cor não ser null
      if (parecer.color == null) {
        return `O parecer indicativo ${parecer.description} está com uma cor não definida!`;
      }

      // Validar para valor inicial ou valor final não passar do valor maximo de 10
      if (parecer.valueStart > 10 || parecer.valueEnd > 10) {
        return `O parecer indicativo não pode ultrapassar o valor de 10!`;
      }

      // Validar para valor inicial não ser maior que valor final
      if (parecer.valueStart > parecer.valueEnd) {
        return `O parecer indicativo ${parecer.description} está com um valor Inicial (${parecer.valueStart}) maior que o valor Final (${parecer.valueEnd})!`;
      }
    }

    // Validar para que o range do parecer não se sobreponha a outro
    const response = validateNumericRangeParecerIndicativo(
      parecerIndicativoList
    );
    if (response !== null) return response;

    return null;
  }

  async saveAccessControl() {
    try {
      const accessControl = this.formGroupAccessControl.getRawValue();

      this.accessControl.timeout = accessControl.timeout;
      this.accessControl.simulAccessWeb = accessControl.simulAccessWeb;
      this.accessControl.simulAccessMobile = accessControl.simulAccessMobile;
      this.accessControl.timeToChangePassword =
        accessControl.timeToChangePassword;

      await this.restService
        .post('access-control', '', this.accessControl)
        .toPromise();
      this.alertService.success('Salvo com sucesso');
    } catch (e) {
      this.alertService.error(e.message);
    } finally {
      this.authService.saving = false;
    }
  }

  async getAccessControl() {
    this.accessControl = new AccessControl();
    try {
      const accessControl = await this.restService
        .getter('access-control', '', '')
        .toPromise();
      this.accessControl = accessControl ? accessControl : new AccessControl();
      this.createFormAccessControl();
    } catch (e) {
      this.alertService.error(e.message);
    }
  }

  createFormResendNotification(): void {
    this.formGroupResendNotification = this.formBuilder.group({
      hours: [
        this.hoursToResendNotification,
        Validators.compose([Validators.required, Validators.maxLength(50)]),
      ],
    });
  }

  private async getHoursToResendNotification(): Promise<void> {
    try {
      const resendNotification = await this.restService
        .getter('resend-notification', '', '')
        .toPromise();
      this.resendNotification = resendNotification
        ? resendNotification
        : new LgpdExpiration();
      if (this.resendNotification.hours) {
        this.hoursToResendNotification = Math.floor(
          this.resendNotification.hours / (1000 * 60 * 60)
        );
      } else {
        this.hoursToResendNotification = 0;
      }
      this.createFormResendNotification();
    } catch (e) {
      this.alertService.error(e.message);
    }
  }

  async saveHoursToResendNotification(): Promise<void> {
    const isNumber = Number(
      this.formGroupResendNotification.getRawValue().hours
    );
    if (Number.isNaN(isNumber)) {
      this.alertService.warning('Valor inválido!');
      this.authService.saving = false;
    } else {
      const milliseconds = Math.trunc(
        parseInt(this.formGroupResendNotification.getRawValue().hours, 10) *
          (1000 * 60 * 60)
      );
      this.resendNotification.hours = milliseconds;
      try {
        await this.restService
          .post('resend-notification', '', this.resendNotification)
          .toPromise();
        this.alertService.success('Salvo com sucesso');
      } catch (e) {
        this.alertService.error(e.message);
      } finally {
        this.authService.saving = false;
      }
    }
  }

  public droppedManual(files: NgxFileDropEntry[]): void {
    if (this.savingManual) return;
    if (files.length && files.length > 1) {
      this.alertService.warning('É permitido o upload de apenas um arquivo.');
      return;
    }
    try {
      this.savingManual = true;
      for (const droppedFile of files) {
        if (droppedFile.fileEntry.isFile) {
          const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
          fileEntry.file(async (file: File) => {
            if (
              this.manual &&
              this.manual.attachment.description === file.name
            ) {
              this.alertService.warning('Nome de arquivo já existente.');
              return;
            }
            const newFile = await this.uploadService
              .checkImageAndResize(file)
              .toPromise();
            this.resizedFiles.push(newFile);
            this.mxUploading.emit(true);

            try {
              this.alertService.info('Realizando Upload do Manual!');
              await this.uploadService.upload(
                this.MANUAL_URL + 'upload',
                newFile
              );
              // Atualiza o anexo em tela caso não ocorra erros
              this.getLastManual();

              this.alertService.success(
                'Arquivo enviado ao servidor e atualizado com sucesso!'
              );
            } catch (e) {
              this.alertService.error(
                'Ocorreu um erro durante envio do manual para o servidor!'
              );
              console.error(e);
            }
          });
        }
      }
    } finally {
      this.savingManual = false;
    }
  }

  public getLastManual(): void {
    this.configurationService
      .getLastManual(this.MANUAL_URL + 'last')
      .then((res) => {
        if (res) this.manual = res;
      });
  }

  removeManual(): void {
    try {
      this.uploadService.delete(this.MANUAL_URL + this.manual.id);
      this.manual = null;
    } catch (e) {
      this.alertService.error('Ocorreu um erro durante remoção do manual!');
      console.error(e);
    }
  }

  downloadManual(): void {
    if (this.manual.attachment.attachmentId) {
      this.uploadService
        .download(`files/${this.manual.attachment.attachmentId}`, {
          responseType: 'blob',
        })
        .subscribe(
          (response: IResponseDownload) => {
            if (response && response.blob)
              importedSaveAs(response.blob, response.fileName);
          },
          (error) => {
            this.alertService.error('Ocorreu um erro ao baixar o manual.');
            console.error(error);
          }
        );
    }
  }

  removeLGPD(): void {
    try {
      this.alertService.info('Deletando termo LGPD.');
      this.uploadService.delete(this.LGPD_URL + this.fileLgpd.id);
      this.alertService.success('Documento deletado.');
      this.fileLgpd = null;
    } catch (e) {
      this.alertService.error('Ocorreu um erro durante remoção do termo LGPD!');
      console.error(e);
    }
  }

  public generateToken(): void {
    if (this.formGroupMailOAuth2.invalid) {
      this.alertService.warning(
        'Dados obrigatórios não informados ou inválidos!'
      );
      this.utilsService.validateAllFormFields(this.formGroupMailOAuth2);
      return;
    }

    const mailConfiguration = this.formGroupMailOAuth2.getRawValue();

    const redirectUri =
      environment.baseUrl + environment.baseApi + 'mailconfiguration/token';

    window.open(
      `https://login.microsoftonline.com/${mailConfiguration.tenantId}/oauth2/v2.0/authorize?client_id=${mailConfiguration.clientId}&response_type=${mailConfiguration.responseType}&redirect_uri=${redirectUri}&response_mode=${mailConfiguration.responseMode}&scope=${mailConfiguration.scope}`,
      '_blank'
    );
  }

  public droppedLogo(files: NgxFileDropEntry[]): void {
    if (this.savingLogo) return;
    if (files.length && files.length > 1) {
      this.alertService.warning('É permitido o upload de apenas um arquivo.');
      return;
    }

    try {
      this.savingLogo = true;
      for (const droppedFile of files) {
        if (droppedFile.fileEntry.isFile) {
          const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
          fileEntry.file(async (file: File) => {
            const newFile = await this.uploadService
              .checkImageAndResize(file)
              .toPromise();
            this.resizedFiles.push(newFile);
            this.mxUploading.emit(true);

            try {
              this.alertService.info('Realizando Upload do logo!');
              await this.uploadService.upload(
                this.LOGO,
                newFile,
                new HttpParams().set('type', this.logoType)
              );
              // Atualiza o anexo em tela caso não ocorra erros
              this.getLogo();

              this.alertService.success(
                'Arquivo enviado ao servidor e atualizado com sucesso!'
              );
            } catch (e) {
              this.alertService.error(
                'Ocorreu um erro durante envio do termo de uso para o servidor!'
              );
              console.error(e);
            }
          });
        }
      }
    } finally {
      this.savingLogo = false;
    }
  }

  getLogo() {
    if (this.logoType != null) {
      this.configurationService
        .getLogo(this.LOGO, false, new HttpParams().set('type', this.logoType))
        .then((res) => {
          if (res) {
            this.logo = res;
            this.uploadService
              .download(`files/${this.logo.attachment.attachmentId}`, {
                responseType: 'blob',
              })
              .subscribe(
                (response: IResponseDownload) => {
                  if (response && response.blob) {
                    const objectURL = URL.createObjectURL(response.blob);
                    this.logoPreview =
                      this.sanitizer.bypassSecurityTrustUrl(objectURL);
                  }
                },
                (error) => {
                  this.alertService.info('Nenhum logo configurado.');
                  console.error(error);
                }
              );
          } else {
            this.logo = null;
            this.logoPreview = null;
          }
        });
    }
  }

  getColor(type: string) {
    this.configurationService
      .getColors(this.COLOR, false)
      .then((res) => {
        if (res) {
          const mainColor = res.find(
            (arrayOfColors) => arrayOfColors.type == type
          );
          this.color = mainColor ? mainColor : new Color();
          this.createFormMainColor();
        } else {
          this.color = new Color();
        }
      })
      .catch((e) => console.log(e));
  }

  removeLogo(): void {
    try {
      this.uploadService.delete(
        this.LOGO,
        new HttpParams().set('type', this.logoType)
      );
      this.logo = null;
      this.logoPreview = '';
    } catch (e) {
      this.alertService.error('Ocorreu um erro durante remoção do logo.');
      console.error(e);
    }
  }

  downloadLogo(): void {
    if (this.logo.attachment.attachmentId) {
      this.uploadService
        .download(`files/${this.logo.attachment.attachmentId}`, {
          responseType: 'blob',
        })
        .subscribe(
          (response: IResponseDownload) => {
            if (response && response.blob)
              importedSaveAs(response.blob, response.fileName);
          },
          (error) => {
            this.alertService.error('Ocorreu um erro ao baixar o logo.');
            console.error(error);
          }
        );
    }
  }

  loadLogoPreview() {
    if (this.logo.attachment.attachmentId) {
      this.uploadService
        .download(`files/${this.logo.attachment.attachmentId}`, {
          responseType: 'blob',
        })
        .subscribe(
          (response: IResponseDownload) => {
            if (response && response.blob) {
              const objectURL = URL.createObjectURL(response.blob);
              this.logoPreview =
                this.sanitizer.bypassSecurityTrustUrl(objectURL);
            }
          },
          (error) => {
            this.alertService.info('Nenhum logo configurado.');
            console.error(error);
          }
        );
    }
  }

  private createFormMainColor(): void {
    this.formGroupMainColor = this.formBuilder.group({
      code: [this.color.code],
      type: ['MAIN'],
    });
  }

  onLogoChange(logoType: any) {
    this.logoType = logoType;
    this.logoPreview = '';
    this.getLogo();
  }

  public fileOver(event) {
    console.log(event);
  }

  public fileLeave(event) {
    console.log(event);
  }

  async saveColor() {
    try {
      if (this.formGroupMainColor.invalid) {
        this.alertService.warning(
          'Dados obrigatórios não informados ou inválidos!'
        );
        this.utilsService.validateAllFormFields(this.formGroupMainColor);
        return;
      }

      const dados = { ...this.color, ...this.formGroupMainColor.getRawValue() };

      await this.restService.post('color', '', dados).toPromise();
      sessionStorage.setItem(
        'colorMain',
        this.formGroupMainColor.getRawValue().code
      );

      this.alertService.success('Salvo com sucesso!');
    } catch (error) {
      this.alertService.error(
        'Ocorreu um erro ao salvar. Verifique os valores e tente novamente'
      );
    } finally {
      this.authService.saving = false;
    }
  }

  onColorChange() {
    this.formGroupMainColor.get('code').setValue(this.color.code);
  }

  async getLastUpdate(): Promise<void> {
    try {
      const gitMergeResponse: any = await this.updateService
        .getLastGitMerge()
        .toPromise();
      const lastUpdate: ISysUpdate = await this.updateService
        .getLastUpdate()
        .toPromise();

      if (lastUpdate.type !== SysUpdateEnum.PRIMEIRO_REGISTRO) {
        if (
          gitMergeResponse[0].state &&
          gitMergeResponse[0].merged_at &&
          gitMergeResponse[0].target_branch === this.targetBranch &&
          gitMergeResponse[0].source_branch === this.currentBranch &&
          gitMergeResponse[0].state === 'merged'
        ) {
          //cria as datas
          const gitMergeDate = new Date(
            gitMergeResponse[0].merged_at
          ).getTime();
          const lastUpdateDate = lastUpdate.date;

          //se houver diferença entre as datas e se a data do gitmerge for maior que adata de lastUpdate, habilite a opção de atualização
          if (gitMergeDate > lastUpdateDate) {
            this.enableUpdate = true;
            this.updateMsg = 'Atualização disponível: ';
            this.updateMsgDetail = `${gitMergeResponse[0].description}`;
          } else {
            this.enableUpdate = false;
            this.updateMsg = 'Sistema atualizado: ';
            this.updateMsgDetail = `Última atualização ${millisecondsToDateStringAndHours(
              lastUpdateDate
            )}`;
          }
        }
      } else {
        // se for primeiro registro, salva para iniciar controle de atualizações
        const savedRegister: ISysUpdate = await this.updateService
          .save({
            description: 'Primeiro registro',
            date: new Date().getTime(),
            implemented: true,
            targetBranch: this.targetBranch,
            sourceBranch: this.currentBranch,
            user: this.user,
            createdAt: null,
            updatedAt: null,
            type: SysUpdateEnum.REGISTRO,
          })
          .toPromise();
        this.updateMsg = 'Sistema atualizado: ';
        this.updateMsgDetail = `Última atualização ${millisecondsToDateString(
          savedRegister.date
        )}`;
        console.log('Primeiro registro salvo: ', savedRegister);
      }
    } catch (error) {
      console.log('Erro ao buscar atualização: ', error);
    }
  }

  async updateSystem(): Promise<void> {
    try {
      const updateRes: ISysUpdate = await this.updateService
        .launchUpdate({
          urlApi: this.jenkinsUrlApi,
          urlView: this.jenkinsUrlView,
          user: this.jenkinsUser,
          password: this.jenkinsPasword,
          environment: this.jenkinsEnvironment,
          targetBranch: this.targetBranch,
          sourceBranch: this.currentBranch,
          sysUser: this.user,
          description: 'Atualização de sistema',
        })
        .toPromise();
      this.alertService.success('Sucesso ao atualizar sistema');
      this.enableUpdateBtn = true;
    } catch (error) {
      this.alertService.warning('Falha ao atualizar: ' + error.error.message);
    }
  }
}

enum PageEnum {
  INDICATOR,
  MAIL,
  CRITERION_GROUP,
  LGPD,
  RESEND_NOTIFICATION,
  CUSTOMIZATION,
  UPDATE,
  ACCESS_CONTROL,
}
